<div>
  <div bsModal #sendEmailModal="bs-modal" class="modal" tabindex="-1" role="dialog" aria-labelledby="dialog-child-name">
    <div class="modal-dialog modal-lg">
      <div class="modal-content">
        <div class="modal-header" style="border-bottom: 0 !important; padding-bottom: 0">
          <button type="button" class="close pull-right" aria-label="Close" (click)="cancel()">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
          <div class="flex d-flex mb-3 mx-4 content-margin">
            <div>
              <span class="mr-2 ml-4 mb-4 font-color">From:</span>
              {{ productType?.emailSender ? productType?.emailSender : 'support&#64;agrisku.com' }}
            </div>
            <div class="ml-4">
              <span class="ml-4 mr-2 mb-4 font-color">Reply-To:</span
              >{{ productType?.emailReplyTo ? productType?.emailReplyTo : 'poultry&#64;agrisku.com' }}
            </div>
          </div>
          <div>
            <form class="content-margin" [formGroup]="form">
              <div class="mb-2">
                <div class="form-group mb-0 d-flex flex mx-4">
                  <label class="font-color mr-4 mt-1" for="emailTo">To:</label>
                  <input id="emailTo" formControlName="to" class="form-control" />
                  <i
                    class="fa fa-times mt-1 icon-w"
                    aria-hidden="true"
                    (click)="resetControlToDefault('to')"
                    *ngIf="this.fieldChanges.to"></i>
                </div>
                <div
                  class="text-danger error-ml-4"
                  *ngIf="form.get('to').errors?.required || form.get('to').errors?.invalidEmails?.invalidEmails == ''">
                  Please enter valid email addresses, separated by commas.
                </div>
                <div
                  class="text-danger ml-4 error-ml-4"
                  *ngIf="
                    form.get('to').errors?.invalidEmails &&
                    form.get('to').errors?.invalidEmails?.invalidEmails &&
                    form.get('to').errors?.invalidEmails?.invalidEmails != ''
                  ">
                  {{ form.get('to').errors?.invalidEmails?.invalidEmails }} is not a valid email
                </div>
                <div class="text-danger ml-4 error-ml-4" *ngIf="form.get('to').errors?.duplicateEmails">
                  Duplicate emails are not allowed.
                </div>
              </div>
              <div class="mb-2">
                <div class="form-group mb-0 d-flex flex mx-4">
                  <label class="font-color mr-4 mt-1" for="emailTo">Cc:</label>

                  <input id="emailTo" formControlName="cc" class="form-control" />
                  <i
                    class="fa fa-times mt-1 icon-w"
                    aria-hidden="true"
                    (click)="resetControlToDefault('cc')"
                    *ngIf="this.fieldChanges.cc"></i>
                </div>
                <div
                  class="text-danger ml-4 error-ml-4"
                  *ngIf="
                    form.get('cc').errors?.invalidEmails &&
                    form.get('cc').errors?.invalidEmails?.invalidEmails &&
                    form.get('cc').errors?.invalidEmails?.invalidEmails != ''
                  ">
                  {{ form.get('cc').errors?.invalidEmails?.invalidEmails }} is not a valid email
                </div>
                <div class="text-danger error-ml-4" *ngIf="form.get('cc').errors?.invalidEmails?.invalidEmails == ''">
                  Please enter valid email addresses, separated by commas.
                </div>
                <div class="text-danger ml-4 error-ml-4" *ngIf="form.get('cc').errors?.duplicateEmails">
                  Duplicate emails are not allowed.
                </div>
                <!-- Error message for cross-field match -->
                <div class="text-danger error-ml-4" *ngIf="form.errors?.emailsCrossMatch">
                  Email addresses in Cc and To fields must be different.
                </div>
              </div>
              <div class="mb-2">
                <div class="form-group mb-0 d-flex flex mx-4">
                  <label class="font-color mr-4 mt-1" for="subject">Subject:</label>

                  <input id="subject" formControlName="subject" class="form-control" />
                  <i
                    class="fa fa-times mt-1 icon-w"
                    aria-hidden="true"
                    (click)="resetControlToDefault('subject')"
                    *ngIf="this.fieldChanges.subject"></i>
                </div>
                <div
                  class="text-danger margin-4rem"
                  *ngIf="
                    form.get('subject').errors?.required ||
                    form.get('subject').errors?.invalidEmails?.invalidEmails == ''
                  ">
                  Subject is required
                </div>
              </div>
              <div class="content">
                <div [innerHTML]="emailContents[0]"></div>

                <!-- for Customer URL -->
                <div class="word-break-link" [innerHTML]="emailContents[1]"></div>

                <!-- for Inspection report MSG -->
                <div [innerHTML]="emailContents[2]"></div>

                <!-- for Custom Editor -->
                <div id="toolbar-container" style="padding-left: 5px"></div>
                <div class="form-group" style="padding-left: 5px">
                  <editor #editor [init]="tinyInit" formControlName="customField"></editor>
                </div>

                <div [innerHTML]="emailContents[3]"></div>
              </div>
            </form>
            <div style="text-align: center">
              <button type="button" class="btn btn-primary aru" [disabled]="!form.valid" (click)="sendEmail()">
                Send Email
              </button>
              <button type="button" class="btn btn-default aru" (click)="cancel()">Cancel</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
